import { useEffect, useState } from 'react';

import {
  Box,
  Alert,
  AlertTitle,
  AlertDescription,
  AlertIcon,
  Text,
  HStack,
} from '@chakra-ui/react';

const TokenXCreditCard = ({
  token,
  tokenExID,
  authenticationKey,
  origin,
  timestamp,
  cvvToken,
  cvvAuthenticationKey,
  paymentId,
}: {
  token: string;
  tokenExID: string;
  authenticationKey: string;
  origin: string;
  timestamp: string;
  cvvToken?: string | null;
  cvvAuthenticationKey?: string | null;
  paymentId: number;
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const hasSeparateCvvToken = Boolean(cvvToken && cvvAuthenticationKey);

  const cardContainerId = `cardNumber`;
  const cvvContainerId = `cvvNumber`;


  useEffect(() => {
    // @ts-ignore
    if (!window.TokenEx) {
      setError('TokenEx script is not loaded');
      setIsLoading(false);
      return;
    }

    try {
      // PAN detokenize iframe
      const panConfig: Record<string, any> = {
        tokenExID,
        authenticationKey,
        origin,
        timestamp,
        token,
        expiresInSeconds: 60,
      };

      // Backward compat: old records had CVV associated with PAN token in TokenEx vault
      if (!hasSeparateCvvToken) {
        panConfig.cvv = true;
        panConfig.cvvContainerID = cvvContainerId;
      }


      // @ts-ignore
      const panIframe = new window.TokenEx.DetokenizeIframe(cardContainerId, panConfig);

      panIframe.on('load', () => {
        setIsLoading(false);
        setError(null);
      });
      panIframe.on('error', (errorData: any) => {
        const errorMsg =
          errorData?.message || JSON.stringify(errorData) || 'Unknown error';
        setError(errorMsg);
        setIsLoading(false);
      });
      panIframe.load();

      // New records: separate CVV detokenize iframe
      if (hasSeparateCvvToken) {
        // @ts-ignore
        const cvvIframe = new window.TokenEx.DetokenizeIframe(cvvContainerId, {
          tokenExID,
          authenticationKey: cvvAuthenticationKey,
          origin,
          timestamp,
          token: cvvToken,
          expiresInSeconds: 60,
        });
          
        cvvIframe.load();
      }
    } catch (err: any) {
      const errorMsg = err.message || 'Failed to initialize TokenX';
      setError(errorMsg);
      setIsLoading(false);
    }
  }, [
    token,
    tokenExID,
    authenticationKey,
    origin,
    timestamp,
    cvvToken,
    cvvAuthenticationKey,
    cardContainerId,
    cvvContainerId,
    hasSeparateCvvToken,
    paymentId,
  ]);

  return (
    <>
      {isLoading && <div>Loading...</div>}
      {error && (
        <Alert status="error">
          <AlertIcon />
          <AlertTitle>TokenX</AlertTitle>
          <AlertDescription>{error}</AlertDescription>
        </Alert>
      )}
      <HStack spacing={3} align="center" mb={3}>
        <Text fontSize="sm" fontWeight="medium" minW="90px">
          Card Number:
        </Text>
        <Box h="20px" flex="1">
          <div id={cardContainerId}></div>
        </Box>
      </HStack>
      <HStack spacing={3} align="center">
        <Text fontSize="sm" fontWeight="medium" minW="90px">
          CVV:
        </Text>
        <Box h="20px" flex="1">
            <div id={cvvContainerId}></div>
        </Box>
      </HStack>
    </>
  );
};

export default TokenXCreditCard;
